import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface ColumnSortHeaderProps<T extends string> {
	activeField: T | null;
	direction: SortDirection;
	field: T;
	label: string;
	onSort: (field: T) => void;
}

export type SortField<T extends string = string> = T[];
export type SortDirection = "asc" | "desc";

export const ColumnSortHeader = <T extends string>({
	label,
	field,
	activeField,
	direction,
	onSort,
}: ColumnSortHeaderProps<T>) => {
	const isActive = activeField === field;

	return (
		<th className="px-3 py-3">
			<button
				type="button"
				onClick={() => onSort(field)}
				className="flex items-center gap-1 font-medium text-gray-600 hover:text-gray-900"
				data-testid={`sort-${field}`}
			>
				{label}
				<span className="flex flex-col">
					<FiChevronUp
						size={12}
						className={
							isActive && direction === "asc"
								? "text-blue-600"
								: "text-gray-300"
						}
					/>
					<FiChevronDown
						size={12}
						className={
							isActive && direction === "desc"
								? "text-blue-600"
								: "text-gray-300"
						}
						style={{ marginTop: -4 }}
					/>
				</span>
			</button>
		</th>
	);
};